const addItem = (data) => {
    return {
        type: "ADD_ITEM_DATA",
        data
    }
}

const removeItem = (data) => {
    return {
        type: "REMOVE_ITEM_DATA",
        data
    }
}

const deleteItem = (data) => {
    return {
        type: "DELETE_ITEM_DATA",
        data
    }
}

export { addItem , removeItem , deleteItem }